// pressCardApi.ts
// 팝플(팝콘플래닛) 어린이 기자단 기자증 API
// 스펙: GET /api/members/press-card?userId={profile_id} (Popcorn-Jmix)
//   - 팝콘 백엔드(popcornplanet) 직접 호출 (동아 dsapi 게이트웨이 경유 아님)
//   - userId: MyContext user.id (= profile_id, "TMPDS..." 형태)
//   - isIssued: 발급 이력 존재 여부
//   - isValid : status === ACTIVE && 유효기간 이내 → 메뉴 분기 기준
//   - status  : ACTIVE / EXPIRED / REVOKED / null(미발급)

export type PressCardStatus = "ACTIVE" | "EXPIRED" | "REVOKED" | null;

export interface PressCardData {
  isIssued: boolean;
  isValid: boolean;
  status: PressCardStatus;
  validFrom: string | null;
  validUntil: string | null;
  cardNumber: string | null;
  reporterName: string | null;
  photoUrl: string | null;
  memberLevel: number | null;
  remainingPhotoModifications: number | null;
  remainingNameModifications: number | null;
}

interface PressCardApiResponse {
  success: boolean;
  code: string;
  data: PressCardData | null;
}

// 비로그인 / 조회 실패 시 미발급으로 기본 처리
export const EMPTY_PRESS_CARD: PressCardData = {
  isIssued: false,
  isValid: false,
  status: null,
  validFrom: null,
  validUntil: null,
  cardNumber: null,
  reporterName: null,
  photoUrl: null,
  memberLevel: null,
  remainingPhotoModifications: null,
  remainingNameModifications: null,
};

// 팝콘 백엔드(popcornplanet) 기자증 조회 경로
const PRESS_CARD_PATH = "/api/members/press-card";

/**
 * 기자증 상태 조회
 * @param userId MyContext user.id (= profile_id, "TMPDS..." 형태)
 * @returns PressCardData (userId 없음/조회 실패 시 EMPTY_PRESS_CARD)
 */
export const fetchPressCardStatus = async (
  userId: string | null
): Promise<PressCardData> => {
  // 비로그인(userId 없음) → 미발급 기본 처리
  if (!userId) {
    return EMPTY_PRESS_CARD;
  }

  try {
    const result = await fetch(
      `${process.env.REACT_APP_POPCORN_API_URL}${PRESS_CARD_PATH}?userId=${encodeURIComponent(
        userId
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (!result.ok) {
      return EMPTY_PRESS_CARD;
    }

    const resData: PressCardApiResponse = await result.json();
    return resData?.data ?? EMPTY_PRESS_CARD;
  } catch (error) {
    console.error("Failed to fetch press card status:", error);
    return EMPTY_PRESS_CARD;
  }
};
